import { render, staticRenderFns } from "./WhatsappFloat.vue?vue&type=template&id=46895cb0&scoped=true"
var script = {}
import style0 from "./WhatsappFloat.vue?vue&type=style&index=0&id=46895cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46895cb0",
  null
  
)

export default component.exports